export default __webpack_public_path__ + "static/media/img6.80123f62.jpg";